<template>
  <div class="rounded-3xl bg-gray-200 flex flex-col space-y-4 p-12 w-full">
    <p class="text-lg flex-grow-0 flex-inline">
      <span class="h-1 bg-expo_red w-12 block mb-6"></span>
      <span class="w-full">Dates and Venues</span>
    </p>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-x-8 gap-y-6">
      <div v-for="(item, i) in events" :key="i">
        <h5 class="font-bold text-gray-500 font-poppins text-sm">
          {{ item.title }}
        </h5>
        <p class="text-gray-500 text-sm">{{ item.date_range }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      events: 'expo/getEvents',
    }),
  },
}
</script>
